import React from 'react';
import SpellingTrainer from './components/SpellingTrainer';

function App() {
  return <SpellingTrainer />;
}

export default App;
